module.exports = __webpack_public_path__ + "static/media/promo_default.073ff7dc.png";